import { ListOfCountries } from './countries.constants';

export const INITIAL_DISONA_PROFILE_STATE = {
  avatarUrl: '',
  image_avatar: '',
  nickName: '',
  fullName: '',
  dateOfBirth: '',
  phone: '',
  email: '',
  password: '',
  address: '',
  countryOfResidence: ListOfCountries.find((el) => el.value === 'IND').value,
  nationality: ListOfCountries.find((el) => el.value === 'IND').value,
  natureOfBusinessOrProfessionOrIndustry: '',
  statusOfEmployment: '',
  reasonForOpeningTheAccount: '',
  estimatedAnnualIncome: '',
  estimatedNetWorth: '',
  originOfIncomeAndWealth: '',
  sourceOfFunds: '',
  tradingExperience: '',
  relevantKnowledgeToUnderstandTheRisksInvolved: '',
  twoFactorAuthByEmail: false,
  twoFactorAuthBySms: false,
  notificationSound: false,
  desktopNotifications: false,
  emailAboutSuspiciousSignInAttempts: false,
  emailWhenNewIdeaIsPublished: false,
  notifyByEmailAboutAutomatedDeals: false,
  notifyOnSiteAboutAutomatedDeals: false,
  notifyByEmailAboutAutomatedPositionEdits: false,
  notifyOnSiteAboutAutomatedPositionEdits: false,
  notifyByEmailAboutManualDeals: false,
  notifyOnSiteAboutManualDeals: false,
  notifyByEmailAboutManualPositionEdits: false,
  notifyOnSiteAboutManualPositionEdits: false,
};

const ListOfNatureOfBusinessOrProfessionOrIndustry = [
  { label: 'Accountancy', value: 'Accountancy' },
  { label: 'Admin/ Secretarial', value: 'Admin/ Secretarial' },
  { label: 'Financial Services', value: 'Financial Services' },
  { label: 'Education', value: 'Education' },
  { label: 'Engineering', value: 'Engineering' },
  { label: 'Healthcare', value: 'Healthcare' },
  { label: 'Marketing', value: 'Marketing' },
  { label: 'OTHER', value: 'OTHER' },
];

const ListOfStatusOfEmployment = [
  { label: 'Employed (full-time)', value: 'Employed (full-time)' },
  { label: 'Self employed', value: 'Self employed' },
  { label: 'Employed (part-time)', value: 'Employed (part-time)' },
  { label: 'Unemployed', value: 'Unemployed' },
  { label: 'Retired', value: 'Retired' },
];

const ListOfReasonForOpeningTheAccount = [
  { label: 'Investment', value: 'Investment' },
  { label: 'Hedging', value: 'Hedging' },
  { label: 'Speculation', value: 'Speculation' },
];

const ListOfEstimatedAnnualIncome = [
  { label: '$0 - $20,000', value: '$0 - $20,000' },
  { label: '$20,000 - $50,000', value: '$20,000 - $50,000' },
  { label: '$50,000 - $100,000', value: '$50,000 - $100,000' },
  { label: 'More than $100,000', value: 'More than $100,000' },
];

const ListOfEstimatedNetWorth = [
  { label: '$0 - $20,000', value: '$0 - $20,000' },
  { label: '$20,000 - $50,000', value: '$20,000 - $50,000' },
  { label: '$50,000 - $100,000', value: '$50,000 - $100,000' },
  { label: 'More than $100,000', value: 'More than $100,000' },
];

const ListOforiginOfIncomeAndWealth = [
  {
    label: 'Employment/Business Proceeds',
    value: 'Employment/Business Proceeds',
  },
  { label: 'Savings', value: 'Savings' },
  { label: 'Rent', value: 'Rent' },
  { label: 'Borrowing/ Loan', value: 'Borrowing/ Loan' },
  { label: 'Pension', value: 'Pension' },
  { label: 'Inheritance', value: 'Inheritance' },
  { label: 'OTHER', value: 'OTHER' },
];

const ListOfSourceOfFunds = [
  {
    label: 'Employment/Business Proceeds',
    value: 'Employment/Business Proceeds',
  },
  { label: 'Savings', value: 'Savings' },
  { label: 'Rent', value: 'Rent' },
  { label: 'Borrowing/ Loan', value: 'Borrowing/ Loan' },
  { label: 'Pension', value: 'Pension' },
  { label: 'Inheritance', value: 'Inheritance' },
  { label: 'OTHER', value: 'OTHER' },
];
const ListOfTradingExperience = [
  {
    label: 'Yes, less than 1 year’s trading experience',
    value: 'Yes, less than 1 year’s trading experience',
  },
  {
    label: 'Yes, 1+ years’ trading experience',
    value: 'Yes, 1+ years’ trading experience',
  },
  { label: 'No trading experience', value: 'No trading experience' },
];

const ListOfRelevantKnowledgeToUnderstandTheRisksInvolved = [
  { label: 'Yes', value: 'Yes' },
  { label: 'No', value: 'No' },
];

export const AUTO_FILL_LIST = {
  ListOfNatureOfBusinessOrProfessionOrIndustry,
  ListOfStatusOfEmployment,
  ListOfReasonForOpeningTheAccount,
  ListOfEstimatedAnnualIncome,
  ListOfEstimatedNetWorth,
  ListOforiginOfIncomeAndWealth,
  ListOfSourceOfFunds,
  ListOfTradingExperience,
  ListOfRelevantKnowledgeToUnderstandTheRisksInvolved,
};

export const KYC_REQUIRED_MODAL_ID = 'kyc-required-modal';
export const BLOCKED_DEPOSIT_MODAL_ID = 'blocked-deposit-modal';
export const BLOCKED_WITHDRAWAL_MODAL_ID = 'blocked-withdrawal-modal';

export const BLOCKED_BONUS_MODAL_ID = 'blocked-bonus-modal';

export const USER_ACCESS_CODES = {
  StateNotLoggedIn: 0x000,
  StateCreated: 0x001,
  StateRegistered: 0x003,
  StateActivated: 0x007,
  BlockBonus: 0x10,
  BlockDeposit: 0x20,
  BlockWithdraw: 0x40,
  RequestKYCDoc: 0x100,
  RequestKYCDone: 0x200,
};

export const INITIAL_USER_ACCESS_STATE = {
  StateNotLoggedIn: false,
  StateCreated: false,
  StateRegistered: false,
  StateActivated: false,
  BlockBonus: false,
  BlockDeposit: false,
  BlockWithdraw: false,
  RequestKYCDoc: false,
  RequestKYCDone: false,
};
export const needInfoMapingForHaveRealAccount = [
  'dateOfBirth',
  'countryOfResidence',
  'nationality',
  'natureOfBusinessOrProfessionOrIndustry',
  'statusOfEmployment',
  'address',
  'reasonForOpeningTheAccount',
  'estimatedAnnualIncome',
  'estimatedNetWorth',
  'originOfIncomeAndWealth',
  'sourceOfFunds',
  'tradingExperience',
  'relevantKnowledgeToUnderstandTheRisksInvolved',
];
export const prefilledFields = [
  'countryOfResidence',
  'nationality',
  'natureOfBusinessOrProfessionOrIndustry',
  'statusOfEmployment',
  'reasonForOpeningTheAccount',
  'estimatedAnnualIncome',
  'estimatedNetWorth',
  'originOfIncomeAndWealth',
  'sourceOfFunds',
  'tradingExperience',
  'relevantKnowledgeToUnderstandTheRisksInvolved',
];
export const wizardNecessaryProfileData = [
  'lastName',
  'firstName',
  'dateOfBirth',
  'nationality',
  'region',
  'email',
  'phone',
  'countryOfResidence',
  'natureOfBusinessOrProfessionOrIndustry',
  'statusOfEmployment',
  'address',
  'reasonForOpeningTheAccount',
  'estimatedAnnualIncome',
  'estimatedNetWorth',
  'originOfIncomeAndWealth',
  'sourceOfFunds',
  'tradingExperience',
  'relevantKnowledgeToUnderstandTheRisksInvolved',
];
export const checkProfileStage = {
  'stage-1': [
    'lastName',
    'firstName',
    'dateOfBirth',
    'nationality',
    'email',
    'phone',
  ],
  'stage-2': ['countryOfResidence', 'address'],
  'stage-3': [
    'natureOfBusinessOrProfessionOrIndustry',
    'statusOfEmployment',
    'reasonForOpeningTheAccount',
    'estimatedAnnualIncome',
    'estimatedNetWorth',
    'originOfIncomeAndWealth',
    'sourceOfFunds',
  ],
  'stage-4': [
    'tradingExperience',
    'relevantKnowledgeToUnderstandTheRisksInvolved',
  ],
};
